import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import { Copy } from "../../../../utils";

import { CopyButton } from "./index.styles";

type UPCButtonProps = {
  caption: string;
  desc: string;
  handleCopy: (caption: string) => void;
};
const UPCButton: React.FC<UPCButtonProps> = ({ caption, desc, handleCopy }) => {
  return (
    <CopyButton
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleCopy(caption);
      }}
      onKeyDown={(e) => {
        e.preventDefault();
        if (e.key === "Enter" || e.key === " ") {
          handleCopy(caption);
        }
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", width: "49px" }}>
        <img src={Copy} alt="copy" />
        <Typography
          variant="subtitle1"
          sx={{
            color: "#717680",
            lineHeight: "18px",
          }}
        >
          {caption}:
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: "#181d27",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "18px",
        }}
      >
        {desc}
      </Typography>
    </CopyButton>
  );
};

export default UPCButton;
